<p-toast></p-toast>
<div class="h-full center-container">
    <div class="grid">
        <div class="card">
            <h2 class="text-center">Login</h2>
            <div class="col-12">
                <form [formGroup]="loginFormGroup" autocomplete="off">
                    <div class="grid p-fluid mt-5">
                        <div class="field flex-column col-12">
                            <label for="username" class="label-required w-full">Username</label>
                            <input pInputText id="username" formControlName="username" />
                            <div *ngIf="formSubmitted && loginFormGroup.controls['username'].errors">
                                <div class="ui-messages-error"
                                    *ngIf="loginFormGroup.controls['username'].errors?.['required']">
                                    Please enter username.
                                </div>
                            </div>
                        </div>

                        <div class="field flex-column col-12">
                            <label for="password" class="label-required w-full">Password</label>
                            <p-password inputId="password" formControlName="password"  autocomplete="new-password" [feedback]="false" class="w-full"/>
                            <div *ngIf="formSubmitted && loginFormGroup.controls['password'].errors">
                                <div class="ui-messages-error"
                                    *ngIf="loginFormGroup.controls['password'].errors?.['required']">
                                    Please enter password.
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <p-button [loading]="loginInProgress" label="Login" (click)="login()"></p-button>
                                
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>